import React from "react";
import LinksColumn from './LinksColumn';
import { footerLinks } from '../../config/app';
import WhiteLogo from "../elements/WhiteLogo";

export default class RightBlock extends React.PureComponent {
    render() {
        return (
            <div className={'right-block'}>
                <div className={'footer-inner'}>
                    <WhiteLogo/>

                    <div className={'title'}>Sitemap</div>

                    <div className={'links'}>
                        <LinksColumn links={footerLinks.left} type={'left'}/>
                        <LinksColumn links={footerLinks.right} type={'right'}/>
                    </div>
                </div>
            </div>
        );
    }
}

